// actions/employee-onboarding/notify.js

import { attachAuth } from '../../utils/authService';

export function notifyHasErrored(bool) {
  return {
    type: 'ONBOARDING_NOTIFY_HAS_ERRORED',
    hasErrored: bool
  };
}

export function notifyIsLoading(bool) {
  return {
    type: 'ONBOARDING_NOTIFY_IS_LOADING',
    isLoading: bool
  };
}

export function notifyFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_NOTIFY_FETCH_DATA_SUCCESS',
    data
  };
}

export function notifyFetchData(host, group) {
  return (dispatch) => {
    dispatch(notifyIsLoading(true));
    dispatch(notifyHasErrored(false));
    fetch(host + 'approve/notify?group=' + encodeURIComponent(group), {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(notifyFetchDataSuccess(result));
            dispatch(notifyHasErrored(false));
            dispatch(notifyIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(notifyHasErrored(true));
            dispatch(notifyIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(notifyHasErrored(true));
      dispatch(notifyIsLoading(false));
    });
  };
}